import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/hud.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Strip console.log in production, keep warn/error for real issues
if (process.env.NODE_ENV === 'production') {
   console.log = () => {};
}

// Disable zoom on all devices by adding viewport meta tag
const metaViewport = document.querySelector('meta[name="viewport"]');
if (metaViewport) {
   metaViewport.setAttribute(
      'content',
      'width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no'
   );
} else {
   const meta = document.createElement('meta');
   meta.name = 'viewport';
   meta.content = 'width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no';
   document.head.appendChild(meta);
}

// Prevent pinch-to-zoom gesture
document.addEventListener('gesturestart', (e) => e.preventDefault());
document.addEventListener('gesturechange', (e) => e.preventDefault());
document.addEventListener('gestureend', (e) => e.preventDefault());

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
   <React.StrictMode>
      <App />
   </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
